import { Box } from "@mui/material";
import React from "react";

export default function Loading({ inline = false, size = "25px" }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: !inline ? "100dvh" : size,
        width: !inline ? "100%" : size,
        flexDirection: "column",
      }}
    >
      <img
        src="/animations/Loading.gif"
        alt="Loading spinner"
        style={{
          width: !inline ? "50px" : size,
          height: !inline ? "50px" : size,
          pointerEvents: "none",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
